
import React from "react";
import { CardTitle } from "@/components/ui/card";
import { Code, PlusCircle, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SkillsHeaderProps {
  setIsAdding: (value: boolean) => void;
  isAdding: boolean;
  freelancerId?: string | null;
}

export const SkillsHeader = ({ setIsAdding, isAdding, freelancerId }: SkillsHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <CardTitle className="text-xl flex items-center gap-2">
        <div className="w-8 h-8 rounded-full bg-gradient-to-r from-blue-400 to-emerald-400 flex items-center justify-center shadow-inner">
          <Code className="w-5 h-5 text-white" />
        </div>
        <span className="bg-gradient-to-r from-blue-600 to-emerald-600 bg-clip-text text-transparent">
          Skills & Expertise
        </span>
      </CardTitle>
      { !freelancerId &&
      <Button 
        variant="outline" 
        size="sm" 
        onClick={() => setIsAdding(!isAdding)}
        className="border border-blue-200 hover:border-blue-300 hover:bg-gradient-to-r hover:from-blue-50 hover:to-emerald-50 flex items-center gap-1.5 transition-all shadow-sm hover:shadow"
      >
        <PlusCircle className="w-4 h-4 text-blue-500" />
        Add Skill
      </Button>
      }
    </div>
  );
};
